/**
 * AlertDialog - Generic alert dialog component
 */

import type { Component } from 'react';

const React = (window as any).React;
const ReactComponent = React.Component;

interface AlertDialogProps {
    title: string;
    message: string;
    onClose: () => void;
}

class AlertDialog extends ReactComponent<AlertDialogProps> {
    render(): any {
        const DialogComponent = (window as any).Dialog;
        if (!DialogComponent) return null;

        return React.createElement(DialogComponent, {
            title: this.props.title,
            onClose: this.props.onClose,
            actionButtons: React.createElement('button', {
                className: 'btn',
                onClick: this.props.onClose
            }, 'OK'),
            closeOnBackdropClick: false
        },
            React.createElement('div', { style: { padding: '20px' } },
                React.createElement('p', { style: { margin: 0, color: 'var(--main-text-color)' } }, this.props.message)
            )
        );
    }
}

(window as any).AlertDialog = AlertDialog;
export default AlertDialog;
